/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CreateContactPersonToPartnerV1Dto = {
  /**
   * The uuid of the contact-person linked to this relation. As 8-4-4-4-12 format.
   */
  contactPersonId: string;
  /**
   * The uuid of the partner linked to this relation. As 8-4-4-4-12 format.
   */
  partnerId: string;
  /**
   * Role of the contact person in the partner
   */
  role?: CreateContactPersonToPartnerV1Dto.role;
  /**
   * Job title of the contact person in the partner
   */
  jobTitle?: string;
};
export namespace CreateContactPersonToPartnerV1Dto {
  /**
   * Role of the contact person in the partner
   */
  export enum role {
    OWNER = 'Owner',
    TENANT = 'Tenant',
    PROPERTY_MANAGER = 'PropertyManager',
    FACILITY_MANAGER = 'FacilityManager',
    SERVICE_PROVIDER = 'ServiceProvider',
    OTHER = 'Other',
  }
}
